import { Injectable } from '@angular/core';
import { InvocaService } from '../../base/services/invoca.service';

@Injectable({ providedIn: 'root' },)
export class WebpayService {

    constructor(private invoke: InvocaService) { }

    async setTokenWebpay(id: string): Promise<any> {
        return await this.invoke.httpInvoke('setTokenWebpay', { uid: id });
    }

    async getInformacion(id: string): Promise<any> {
        return await this.invoke.httpInvoke('getInformacionUID', { uid: id });
    }

    async enviaCorreo(correo: string, respuesta: any): Promise<any> {
        return await this.invoke.httpInvoke('enviaCorreo', { email: correo, datos: respuesta });
    }

    async limpiaPagoUidTest(id: string): Promise<any> {
        return await this.invoke.httpInvoke('limpiaPagoUidTest', { uid: id });
    }

    getQueryParams(url) {
        const paramArr = url.slice(url.indexOf('?') + 1).split('&');
        const params = {};
        paramArr.map(param => {
            const [key, val] = param.split('=');
            params[key] = decodeURIComponent(val);
        })
        return params;
    }

    async setBotonVolver(uid: string, retorno: string) {
        try {
            if (uid != null) {
                return await this.invoke.httpInvoke('saltoSistemaPorRedis', { uid: uid });
            }
        } catch (e) {
            if (retorno != undefined && retorno != null && retorno.length > 0) {
                return retorno;
            } else {
                return 'https://portal.uv.cl/';
            }
        }
    }
}